<template lang="pug">
.c-cms-past-chairmans
  staffs-editor(title="14屆會務名冊"
    id="14_staffs")
</template>

<script>
import StaffsEditor from "@/components/cms/StaffsEditor.vue";

export default {
  name: "Cms14thStaffs",
  components: {
    StaffsEditor
  }
};
</script>
